import { render } from "./GeneralInput.vue?vue&type=template&id=ff18f1f8"
import script from "./GeneralInput.vue?vue&type=script&lang=js"
export * from "./GeneralInput.vue?vue&type=script&lang=js"

import "./GeneralInput.vue?vue&type=style&index=0&id=ff18f1f8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__